import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getTasks } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { setTasks, useTaskStore } from 'store/task';
import { Task } from 'models/task.model';
import { DURATIONS } from 'common/constants';
import { taskKeys } from './queryKeys';
import { AllStatuses } from 'interfaces';

export const useTaskById = (id: string) => {
  const queryClient = useQueryClient();
  const all = queryClient.getQueryData<Task[]>(taskKeys.all);
  const active = all?.filter((b) => b.id === id);

  return active ? active[0] : null;
};

export const useTaskGetAllQuery = () => {
  const draft = useTaskStore((state) => state.draft);
  const toast = useToast();

  const isDraftSaved = draft?.status !== AllStatuses.NOT_SAVED;

  const query = useQuery({
    queryKey: taskKeys.all,
    queryFn: () => getTasks({}),
    staleTime: 0,
    refetchInterval: isDraftSaved && DURATIONS.MINUTES_5,
    refetchIntervalInBackground: isDraftSaved,
    refetchOnReconnect: isDraftSaved,
    refetchOnWindowFocus: isDraftSaved,
  });

  const { data, error } = query;

  useEffect(() => {
    if (data) {
      setTasks(data);
    }
  }, [data]);

  useEffect(() => {
    if (error) toast.error(error.message);
  }, [error, toast]);

  return query;
};
